import { formatNumber } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Area, FT2_TO_M2 } from 'app/shared/ll/models/units';


export const formatAreaImperial = (locale: string, value: any, decimals = 2): string | null => {
    if (!Number.isFinite(value)) {
        return null;
    }
    const area = new Area(value * FT2_TO_M2);
    const i = area.getQuantity(true);
    return `${formatNumber(i.value, locale, `1.${decimals}-${decimals}`)} ${i.unit}`;
};


@Pipe({
    name: 'areaImperial',
})
export class AreaImperialPipe implements PipeTransform {

    private locale = inject<string>(LOCALE_ID);

    transform(value: any, decimals = 2) {
        return formatAreaImperial(this.locale, value, decimals);
    }
}
